






































































import { Component, Vue, PropSync } from 'vue-property-decorator'
import { fileUploader } from '@/services/qiniu.service.new'
import UUID from 'uuidjs'

@Component
export default class DistributorEditor extends Vue {
  @PropSync('distributor', {
    type: Object,
    default: () => ({
      name: '',
      email: '',
      tel: '',
      address: '',
      introduction: '',
      contracts: [],
    }),
  })
  private distributorEditor!: any
  private sections: Array<any> = []
  private distributorYears: Array<any> = []

  private get rules(): any {
    return {
      name: [
        {
          required: true,
          message: this.$tc('distributorMgmt.enterDistributorName'),
          trigger: 'change',
        },
        {
          max: 100,
          message: this.$tc('distributorMgmt.distributorNameLimit'),
          trigger: 'change',
        },
      ],
      email: [
        {
          required: true,
          message: this.$tc('distributorMgmt.enterLoginEmail'),
          trigger: 'change',
        },
        {
          max: 100,
          message: this.$tc('distributorMgmt.emailLimit'),
          trigger: 'change',
        },
        {
          type: 'email',
          message: this.$tc('distributorMgmt.enterCorrectEmail'),
          trigger: 'change',
        },
      ],
      tel: [
        {
          max: 100,
          message: this.$tc('distributorMgmt.contactLimit'),
          trigger: 'change',
        },
      ],
      address: [
        {
          max: 500,
          message: this.$tc('distributorMgmt.addressLimit'),
          trigger: 'change',
        },
      ],
      introduction: [
        {
          max: 500,
          message: this.$tc('distributorMgmt.briefLimit'),
          trigger: 'change',
        },
      ],
    }
  }

  private customRequest({ file }): void {
    const index = file.name.lastIndexOf('.')
    const suffix = file.name.slice(index).toLowerCase()
    const originName = file.name.slice(0, index).toLowerCase()
    const fileName = 'file_' + new Date().getTime() + '_' + UUID.genV4() + suffix
    const suffixArray = ['.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png']
    if (suffixArray.includes(suffix)) {
      if (file.size <= 104857600) {
        fileUploader(file, fileName, 'file')
          .then(res => {
            let attachments = this.distributorEditor.contracts
            if (this.distributorEditor.contracts.length < 10) {
              attachments.push({
                uid: res.resourceId,
                url: process.env.VUE_APP_FILE_URL + '/' + res.key,
                name: file.name,
                status: 'done',
              })
            }
            this.$set(this.distributorEditor, 'contracts', attachments)
          })
          .catch(err => {
            console.error(err)
          })
      } else {
        this.$message.error(this.$tc('distributorMgmt.invalidFileSize'))
      }
    } else {
      this.$message.error(this.$tc('distributorMgmt.invalidFileFormat'))
    }
  }

  private removeFile(file): void {
    let index = this.distributorEditor.contracts.indexOf(file)
    let tempList = this.distributorEditor.contracts
    tempList.splice(index, 1)
    this.$set(this.distributorEditor, 'contracts', tempList)
  }
}
